import { toNumber, normalizeSelectInput } from "../../../../helpers";
import ibsStore from "../../../Stores/IbsSurveyStore"
import { NumberFormat, SelectCombosIBS } from "../../../../Enums/constants";
import { columnCalculation } from "../../../../Helpers/TableCalculationHelper";
import { saveValueNew } from "../../../../control";
import { isNumField, renderOptionIconsBtn, renderDeleteIconBtn } from "../../../../Helpers/TableHelper";
import { formatNumber } from "../../../../Helpers/General/FormatHelper";
import { mapToDropdownOption } from '../../../../ibsHelper';
export function createOptionsData(props, referenceToTable, listOfHeaderRows, dataObj) {
        var rowCount = -1;
        listOfHeaderRows = [] //keep track of what rows are headers

        //structure for category sections
        if (ibsStore.allTableResponses[props.tableName]) {
            var unique = [...new Set(ibsStore.allTableResponses[props.tableName].map(item => item?.MainCategoryName))]; // [ 'A', 'B']
        }
        else return;

        unique.forEach(element => {
            var result = [];
            result = ibsStore.allTableResponses[props.tableName].filter(row => row?.MainCategoryName == element);
            //    result = result.sort(sortFunctionByID("AssetClassName"))
            rowCount = rowCount + 1

            //take result and iterate to add to children data rows
            var child = {}
            result.forEach(row => {
                rowCount = rowCount + 1;
                child =
                {
                    ProviderName: row.ProviderName,
                    OptionName: row.OptionName,
                    AssetClassName: row.AssetClassName,
                    Ticker: row.Ticker,
                    ShareClass: row.ShareClass,
                    BMDesc: row.BMDesc,
                    BMReturn: row.BMReturn,
                    Holdings: row.Holdings,
                    ReturnPercent: row.ReturnPercent,
                    CostInvestBps: row.CostInvestBps,
                    CostAdminBps: row.CostAdminBps,
                    TotalExpenseRatio: formatNumber(NumberFormat.BPSDECIMAL1, row.CostInvestBps + row.CostAdminBps),
                    PercentPassive: row.PercentPassive,
                    MandateStyleName: row.MandateStyleName,
                    UseSecLend: mapToDropdownOption(row.UseSecLend, SelectCombosIBS.SECURITIES_LENDING),
                    RowID: row.rowID ?? row.OptionID,
                    del: "",
                    OptionID: row.OptionID,

                }
                dataObj.push(child);
                referenceToTable.push(child);
            })


        });
        let totalRow = {
            ProviderName: "Total",
            OptionName: "",
            AssetClassName: "",
            BMDesc: "",
            BMReturn: "", //columnCalculation("BMReturn", true),
            Holdings: columnCalculation("Holdings", true, props),
            ReturnPercent: "", //columnCalculation("ReturnPercent", true),
            CostInvestBps: "", //columnCalculation("CostInvestBps", true),
            CostAdminBps: "", //columnCalculation("CostAdminBps", true),
            TotalExpenseRatio: "",
            PercentPassive: "", //columnCalculation("PercentPassive", true),
            MandateStyleName: "",
            UseSecLend: "",
            RowID: "Total",
            del: "",
            OptionID: "Total",
        }
        
        dataObj.push(totalRow)
        listOfHeaderRows.push(rowCount)
        referenceToTable.push(totalRow)

        //rowJustAdded = referenceToTable.findIndex((element) => element.OptionID === ibsStore.lastRowAdded)

    return [dataObj, listOfHeaderRows];
    }


export function handleHOTChangeOptions(table, rowNum, qId, oldValue, newValue, props, referenceToTable) {
    if (rowNum !== undefined && rowNum !== null
        && qId !== undefined && qId !== null
        && newValue != oldValue
        && newValue !== 'undefined') { // TODO something weird happens when this is changed to newValue !== oldValue

        let normalizedNewValue = newValue;

        if (isNumField(table, qId, props)) {
            normalizedNewValue = toNumber(newValue);
            if (Number.isNaN(normalizedNewValue)) {
                // It's a number field, but newValue is not a number
                // just save an empty value
                normalizedNewValue = null;
            }
        }

        let rowId, result;

        rowId = referenceToTable[rowNum].OptionID;
        result = ibsStore.allTableResponses[props.tableName].findIndex(row => row.OptionID === rowId); //where it is saved on frontend
        
        if (qId === "UseSecLend") {
            normalizedNewValue = normalizeSelectInput(newValue, SelectCombosIBS.SECURITIES_LENDING)
        }

        ibsStore.allTableResponses[props.tableName][result][qId] = normalizedNewValue;
        let rulesSet = saveValueNew(qId, normalizedNewValue, { tableName: props.tableName, rowId })

    }
}

export function handleOptionsData(props, referenceToTable, listOfHeaderRows, dataObj) {
    let optionsReturnObj = createOptionsData(props, referenceToTable, listOfHeaderRows, dataObj);
    let data = optionsReturnObj[0]
    let headers = optionsReturnObj[1]
    return [data, referenceToTable, headers]
}

export function optionsCellRenderer(instance, td, row, col, prop, value, cellProperties, referenceToTable, props, listOfHeaderRows) {
    let assetClassName = referenceToTable?.[row]?.AssetClassName?.toLowerCase();
    if (prop === "del" && !listOfHeaderRows.includes(row) && td.id !== "undefined") {
        renderDeleteIconBtn(td, row, props, referenceToTable)
        renderOptionIconsBtn(td, row, referenceToTable)
    }
    if (prop == "ProviderName" || prop == "OptionName" || prop == "MandateStyleName" || prop == "AssetClassName" || prop == "ShareClass" || prop == "Ticker" || prop == "UseSecLend") { //Option table?
        td.className = td.className + " readOnlyCell"

    }
    if (prop === "PercentPassive" && !listOfHeaderRows.includes(row) && assetClassName === "balanced / target date") {
        td.innerHTML = "N/A";
        td.className = td.className + " cellNA";
        td.style.textAlign = "right";
        cellProperties.readOnly = true;
    }
    return cellProperties

}
